import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { LogPublisher } from './log-publishers';
import { LogEntry } from './log.model';

export class LogWebApi extends LogPublisher {
    constructor(private http: HttpClient) {
        super();

        this.location = 'http://localhost:56590/api/log';
    }

    log(record: LogEntry): Observable<boolean> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.post(this.location, record, { headers }).pipe(
            map(response => response),
            catchError(this.handleErrors),
        );
    }

    clear(): Observable<boolean> {
        // TODO: Call Web API to clear all log entries
        return of(true);
    }

    private handleErrors(error: HttpErrorResponse): Observable<any> {
        const errors: string[] = [];
        let msg = '';

        msg = 'Status: ' + error.status;
        msg += ' - Status Text: ' + error.statusText;
        msg += ' - Exception Message: ' + error.message;

        errors.push(msg);

        console.error('An error occurred', errors);

        return of(errors);
    }
}
